import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import css from './QueueModal.css';
import StyledButton from '../common/StyledButton';
import { getWord } from '../utils/tenant';
import TimeoutActivity from '../common/TimeoutActivity';

const QueueModal = props => {
  Modal.setAppElement(document.getElementById('main-center'));
  const mainButtonRef = useRef(null);

  function getItemMessage() {
    if (props.actionName === "comment") {
      return <span>for <b>{props.totalActions.toLocaleString('en-US')} {getWord('tracker', true)} items</b></span>
    }
    return <span>to send to <b>{props.totalActions.toLocaleString('en-US')} students</b></span>
  }

  return (
    <Modal
      isOpen={props.isOpen}
      overlayClassName={css['overlay']}
      className={css['modal']}
      onRequestClose={props.onEscape}
      onAfterOpen={() => mainButtonRef.current.focus()}>
      <div className={css['container']}>
        <h1>Your <b>{props.actionName}</b> is in the queue!</h1>
        <h2> A <b>{props.actionName}</b> is in the queue {getItemMessage()}.
          It could take several minutes to complete.
        </h2>
        <img 
          src="../images/starfish/sent.png" 
          aria-hidden="true" 
          className={css['image']}
        />
        <StyledButton
          ref={mainButtonRef} 
          className={css['main-button']}
          onClick={props.onBackToStudentList}>
          Back to Student List
        </StyledButton>
        <StyledButton
          asLink 
          className={css['secondary-button']}
          onClick={props.onSeeItemsInQueue}>
          Review queued items on the Home page
        </StyledButton>
        <div className={css['text-font-size']}>{'Did you make a mistake? There\'s still time to'}         
        <StyledButton
          asLink
          className={`${css['cancel-button']} ${css['cancel-button-padding']}`}
          onClick={props.onCancelBatchAction}>  
          cancel the batch send.
        </StyledButton>
        </div>
      </div>
      <TimeoutActivity
          onTimeout={props.onBackToStudentList} 
          timeoutDurationInSeconds={7} />
    </Modal>
  );
}

QueueModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onEscape: PropTypes.func.isRequired,
  onSeeItemsInQueue: PropTypes.func.isRequired,
  onBackToStudentList: PropTypes.func.isRequired,
  onCancelBatchAction: PropTypes.func.isRequired,
  totalActions: PropTypes.number.isRequired,
  actionName: PropTypes.string.isRequired
};

export default QueueModal;
